import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { eliminarAtencionACliente, eliminarUsuarioAtencionACliente, obtenerEstadisticas } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './UsuariosComponent.module.css'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CredencialComponent from './CredencialComponent'
import { DataGrid } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import Backdrop from '@mui/material/Backdrop';
import { actualizarCliente } from '../../../redux/DucksBeneficiario/ClienteDucks'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1250,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function AsignacionEjecutivosComponent(props) {

    const dispatch = useDispatch()
    const usuarios = props.usuarios
    const idsAociados = props.idsAociados

    const rowsUsuarios = [];
    for (const usuario of usuarios) {
        rowsUsuarios.push(
            { id: uuidv4(), Nombre: usuario.datoslogin.nombre + ' ' + usuario.datoslogin.apellidos, dataUser: usuario,}, 
        )
    }
    const columnsUsuarios = [

        { field: 'Nombre', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Nombre Completo', width: 250 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acción', width: 250,
            renderCell: (params) => (
                <>
                    <button onClick={() => botonReasignarAsociados(params)} className={`btn btn-outline-warning`} >Asignar</button>

                </>
            )

        }
    ]


    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [params, setParams] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setParams(data.params)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setParams('')
    }
    const botonReasignarAsociados = async (params) => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de reasignar asociados a otra cartera.`,
            accion: 'reasignarAsociados',
            params
        })
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style2}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify' }}>
                            {bodyModal}
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'reasignarAsociados':
                                        reasignarAsociados(params)
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const reasignarAsociados = async (params) => {
        for (const i in idsAociados) {
            const data = {
                idcliente: idsAociados[i].id,
                idcartera: params.row.dataUser.datoslogin.idcartera,
            }
            await dispatch(actualizarCliente(data))
        }
        handleCloseModal()
        props.onClose()
        props.onCloseCartera()
    }
    return (
        <Fragment>
            <div className='row justify-content-center'>
                <div className='col-11 bg-white'>
                    <div style={{ height: 500, width: '100%' }}>
                        <DataGrid
                            rows={rowsUsuarios}
                            columns={columnsUsuarios}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            // rowsPerPageOptions={[7]}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            {modalComponent()}
        </Fragment>
    );
};

export default withRouter(AsignacionEjecutivosComponent)